// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3yCy6","vLegacy":"SelectSecondary_vLegacy__o24rj","error":"SelectSecondary_error__lMzKI","disabled":"SelectSecondary_disabled__3qqY2"};